// We have this list because we don't want to add the auth headers to all
// requests, only to requests that require them, so we don't expose the auth
// information to unkown URLs.
const authorizationHeaderSupportedURLList = [
    "/campaign/vmv75/user-registration",
    "/user/auth",
    "/user/balance",
    "/user/bets",
    "/user/betting-lock",
    "/user/budget/",
    "/user/competitions",
    "/user/controlquestionanswer",
    "/user/coupons",
    "/user/deposit",
    "/user/events",
    "/user/gdpr",
    "/user/payin",
    "/user/payment/options",
    "/user/payout",
    "/user/riksandelar",
    "/user/self-exclusion",
    "/user/smsverification/",
    "/user/subscriptions",
    "/user/transactions",
    "/user/withdrawal",
    "/user",

    // TEP rating integration service
    "tokenized-proxy/rating-integration-service/api/v1/rating/riskgroup",

    // Coupons
    "/tokenized-proxy/horse-coupons",
    "/tokenized-proxy/service-horse-bet-history/api/v1/grading",
    "/tokenized-proxy/service-horse-bet-history/api/v1/groupbets",

    // live receipts
    "/tokenized-proxy/service-horse-bet-history/api/v1/single-bets",
    "/tokenized-proxy/service-horse-bet-history/api/v1/single-bet-responses/today",

    // Horse betting
    "/tokenized-proxy/horse-betting",
    "/tokenized-proxy/harry-subscription/api/v1/subscription",
    "/tokenized-proxy/horse-harry-subscription/api/v1/subscriptions",

    // Horse bet history
    "/tokenized-proxy/horse-bet-history/api/v2/bet/transactions",
    "/tokenized-proxy/horse-bet-history/api/v2/bet/receipts",
    "/tokenized-proxy/horse-bet-history/api/v2/refund/bet",

    // Horse bet history only CBH transactions
    "/tokenized-proxy/horse-bet-history/api/v3/bet/transactions",
    "/tokenized-proxy/horse-bet-history/api/v3/bet/receipts",
    "/tokenized-proxy/horse-bet-history/api/v3/offering-bets-metadata",
    "/tokenized-proxy/horse-bet-history/api/v3/offering-bets",
    "/tokenized-proxy/horse-bet-history/api/v3/offering-bets/h2h/events",

    // Horse bet history v4 (includes all sources with partial response support)
    "/tokenized-proxy/horse-bet-history/api/v4/bet/kambi",
    "/tokenized-proxy/horse-bet-history/api/v4/bet/transactions",

    // TEP Horse-bet-notification
    "/tokenized-proxy/horse-bet-notification/api/v2/notification/preferences",

    // TEP ATG-notifications
    "/services/tokenized-proxy/atg-notifications/register",
    "/services/tokenized-proxy/atg-notifications/subscriptions",
    "/services/tokenized-proxy/notifications/api/v1",
    "/tep/notifications/api/v1",
    // Reduction
    "/tokenized-proxy/horse-reduction-calculator",
    "/tokenized-proxy/hrc",

    // TEP Favorites
    "/tokenized-proxy/horse-favorites/api/v2/favorite",
    "/tokenized-proxy/horse-favorites/api/v3/favorite",
    "/tokenized-proxy/horse-favorites/api/v2/favorites/preferences",

    // TEP Favorites v3
    "/tokenized-proxy/horse-favorites/api/v3/favorite/by-race",

    // TEP Payments
    "/tokenized-proxy/payment/api/v1/deposit/creditcard",
    "/tokenized-proxy/payment/api/v2/deposit/creditcard",
    "/tokenized-proxy/payment/api/v1/deposit/swish",
    "/tokenized-proxy/payment/api/v1/deposit/zimpler",
    "/tokenized-proxy/payment/api/v1/deposit/options",
    "/tokenized-proxy/payment/api/v1/deposit/options/creditcard",
    "/tokenized-proxy/payment/api/v1/deposit/trustly",
    "/tokenized-proxy/payment/api/v2/deposit/trustly",
    "/tokenized-proxy/payment/api/v1/deposit/limits",
    "/tokenized-proxy/payment/api/v1/withdrawal/options/bankAccount",
    "/tokenized-proxy/payment/api/v1/customer/requestbaselimitincrease",

    // TEP Payments new
    "/tokenized-proxy/payment/api/v2/withdrawal",
    "/tokenized-proxy/payment/api/v2/withdrawal/options",
    "/tokenized-proxy/payment/api/v2/deposit/limits",

    // TEP payment V3
    "/tokenized-proxy/payment/api/v3/withdrawal",
    "/tokenized-proxy/payment/api/v3/withdrawal/options",

    // TEP customer transactions
    "/tokenized-proxy/customer-transactions/api/v2/result",
    "/tokenized-proxy/customer-transactions/api/v2/result-now",
    "/tokenized-proxy/customer-transactions/api/v2/my-gambling-result",

    // TEP bank account
    "/tokenized-proxy/bas/api/v1/bank-account",

    // TEP customization
    "/tokenized-proxy/cc/api/v1/customization",
    "/tep/cc/api/v1/customization",

    // TEP shopshare & team & coupon team
    "/tokenized-proxy/shopshare/api/v1/shops",
    "/tokenized-proxy/shopshare/api/v1/protected",
    "/tokenized-proxy/shopshare/api/v1/shares",
    "/tokenized-proxy/shopshare/api/v1/subscriptions",
    "/tokenized-proxy/shopshare/api/v1/sport-coupon",
    "/tep/private-shares/api/v1/private-shares",
    "/tokenized-proxy/team/api/v1/teams",
    "/tokenized-proxy/team/api/graphql",
    "/tokenized-proxy/team/api/v1/subscriptions",
    "/tokenized-proxy/team/api/v1/personalization",
    "/tokenized-proxy/team/api/v1/member",
    "/tokenized-proxy/couponteam/api/v1/coupon-team",
    "/tokenized-proxy/shopshare/api/v1/chat",
    "/tokenized-proxy/team/api/v2/chat",
    "/tokenized-proxy/team/api/v1/logs",

    // TEP Member & Member-auth
    "/tokenized-proxy/wallet/api/v3/wallet/balance",
    "/tokenized-proxy/member/api/v4/member",
    "/tokenized-proxy/member/api/v4/member/image",

    // TODO: remove these when v2 is out
    "/tokenized-proxy/member-auth/api/v1/member/login/latest",
    "/tokenized-proxy/member-auth/api/v1/member/contactinfo",
    "/tokenized-proxy/member-auth/api/v1/member/controlquestionanswer",
    "/tokenized-proxy/member-auth/api/v1/member/password",
    "/tokenized-proxy/member-auth/api/v1/member/smsverification/initiate",
    "/tokenized-proxy/member-auth/api/v1/member/smsverification/verify",
    "/tokenized-proxy/member-auth/api/v1/member/smsverification/off",
    "/tokenized-proxy/member-auth/api/v1/member/settings",

    // TEP Member & Member-auth v2
    "/tokenized-proxy/member-auth/api/v2/member/login/latest",
    "/tokenized-proxy/member-auth/api/v2/member/password",
    "/tokenized-proxy/member-auth/api/v2/member/questions",
    "/tokenized-proxy/member-auth/api/v2/member/controlquestionanswer",
    "/tokenized-proxy/member-auth/api/v2/member/smsverification/initiate",
    "/tokenized-proxy/member-auth/api/v2/member/smsverification/verify",
    "/tokenized-proxy/member-auth/api/v2/member/smsverification/off",
    "/tokenized-proxy/member-auth/api/v2/member/settings",
    "/tokenized-proxy/member-auth/api/v2/verification/email/initiate",
    "/tokenized-proxy/member-auth/api/v2/verification/email/apply",

    // RCS
    "/tokenized-proxy/rcs/api/v1/optins",

    // TEP Member Auth Recovery: remove when member auth v2 is out
    "/tokenized-proxy/member-auth/api/v1/recovery/username/email",
    "/tokenized-proxy/member-auth/api/v1/recovery/username/sms",
    "/tokenized-proxy/member-auth/api/v1/recovery/password/sms",
    // not ready in v2 yet
    "/tokenized-proxy/member-auth/api/v1/recovery/username/postal",
    "/tokenized-proxy/member-auth/api/v1/recovery/password/postal",

    // TEP Member Auth Recovery v2
    "/tokenized-proxy/member-auth/api/v2/recovery/username/email",
    "/tokenized-proxy/member-auth/api/v2/recovery/username/sms",
    "/tokenized-proxy/member-auth/api/v2/recovery/password/sms",

    // TEP Account-History
    "/tokenized-proxy/account-history/api/v1/account/transactions",

    // TEP Personal push
    "/tokenized-proxy/subman/api/v1/subscriptions/personal",

    // TEP Casino
    "/tokenized-proxy/rgs/api/v1/rg/constraint/vr",
    "/tokenized/cgc/api/v1/launch",
    "/tokenized/everymatrix/api/v1/jackpot",
    "/tep/casino-push-notifications/api/v1/notifications",
    "/cgc/api/v1/recommendations",

    // TEP Sport - Sportsbook (Kambi)
    "/tokenized/kambi/api/v2/launch",
    "/tokenized/kambi/api/v3/launch",

    // TEP Sport - Big9
    "/tokenized/sports-coupon/api/v1/coupons",
    "/tokenized/sports-bet/api/v1/bet",
    "/tokenized/sports-bet/api/v3/bet",
    "/tokenized/sports-bet/api/v3/bet/reduced",
    "/tokenized/sports-bet/api/v3/receipts",

    // TEP Sport - Big9 (Partner Reduced Betting)
    "/tokenized/reducedbet/api/v1/coupons",
    "/tokenized/partner-reduced-betting-cache/api/v1/coupons",

    // champions (e.g. VM i V75)
    "/tokenized-proxy/horse-champions/api/v1",

    // ElliAssistant - Horse
    "services/tokenized-proxy/elli-gateway/api/horse",

    // New Elli - Horse and Customer Service
    "/services/tokenized-proxy/elli-gateway/api/v1/game-assistant",

    // RGS
    // Duplicate for other verticals as needed
    "/tokenized-proxy/rgs/api/v1/rg/CASINO",
    "/tokenized-proxy/rgs/api/v1/rg/netlosslimit",
    "/tokenized-proxy/rgs/api/v1/rg/netlosslimit/CASINO",
    "/tokenized-proxy/rgs/api/v1/rg/playtimelimit",
    "/tokenized-proxy/rgs/api/v1/rg/playtimelimit/CASINO",
    "/tokenized-proxy/rgs/api/v1/rg/selfexclusion",
    "/tokenized-proxy/rgs/api/v1/rg/selfexclusion/casinopanic",
    "/tokenized-proxy/rgs/api/v1/rg/logintimelimit",
    "/tokenized-proxy/rgs/api/v2/rg/history",
    "/tokenized-proxy/payment/api/v2/deposit/limits/history",

    // KYC
    "tokenized-proxy/kyc/api/v1/questionnaire/",
    "tokenized-proxy/kyc/api/v1/questionnaire/can-see-questionnaire",
    "tokenized-proxy/kyc/api/v1/questionnaire/modal-required",

    // Track commission
    "tokenized/agency-bet-tracking/api/v1/track-bet-placed",

    // Customer Inbox
    "/services/tokenized-proxy/customer-inbox/",

    // Member segmentation
    "/tokenized-proxy/member-segmentation/api/v1/segmentation",

    // Bet suggestions
    "/api/v1/suggestions/generate",

    // Live chat
    "/tokenized-proxy/chat/api/v3/chat/channels/",

    // Log service
    "/tep/client-log-proxy/api/v1/logs",
];

export default authorizationHeaderSupportedURLList;
